"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        color: theme.indigo3,
        textDecoration: 'underline'
    }
});
//# sourceMappingURL=link.style.js.map